import React from 'react';

import { Calendar, ArrowRight, Tag } from 'lucide-react';

const posts = [
  {
    id: 'blog-001',
    tag: 'Transparency',
    title: 'How we verify every beneficiary: our 7-step safeguarding process',
    excerpt: 'We explain exactly how our team reviews applications, checks documentation, and applies safeguarding protocols before any case goes live.',
    date: '08 Apr 2026',
    readTime: '4 min read',
    tagColor: 'bg-teal-50 text-teal-700',
  },
  {
    id: 'blog-002',
    tag: 'Impact Report',
    title: 'Q1 2026: £847,000 raised, 1,241 lives changed',
    excerpt: 'Our quarterly impact report covers every case resolved in Q1 2026, including donor stories, resolution outcomes, and Gift Aid claimed.',
    date: '01 Apr 2026',
    readTime: '6 min read',
    tagColor: 'bg-green-50 text-green-700',
  },
  {
    id: 'blog-003',
    tag: 'Gift Aid',
    title: 'Gift Aid explained: how UK taxpayers can give 25% more at no extra cost',
    excerpt: 'A plain-English guide to Gift Aid, who qualifies, how to declare it, and how much extra your donation generates for causes.',
    date: '25 Mar 2026',
    readTime: '3 min read',
    tagColor: 'bg-amber-50 text-amber-700',
  },
];

export default function BlogSection() {
  return (
    <div className="mb-16" id="blog">
      <div className="flex items-center justify-between mb-6">
        <div>
          <p className="section-label mb-1">Transparency</p>
          <h2 className="font-display text-2xl font-700 text-gray-900">News & Updates</h2>
        </div>
        <button className="text-sm text-teal-600 font-semibold hover:text-teal-700 flex items-center gap-1">
          All articles <ArrowRight size={14} />
        </button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {posts?.map((post) => (
          <div key={post?.id} className="card p-6 hover:shadow-elevated transition-all duration-200 group cursor-pointer">
            <span className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold ${post?.tagColor} mb-3`}>
              <Tag size={10} />
              {post?.tag}
            </span>
            <h3 className="font-display text-base font-700 text-gray-900 leading-snug mb-2 group-hover:text-teal-600 transition-colors">
              {post?.title}
            </h3>
            <p className="text-sm text-gray-500 leading-relaxed mb-4">{post?.excerpt}</p>
            <div className="flex items-center gap-3 text-xs text-gray-400">
              <span className="flex items-center gap-1"><Calendar size={11} />{post?.date}</span>
              <span>·</span>
              <span>{post?.readTime}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}